import React from "react";


function Administration() {
  return (
    <div>
      <div className="row banner" style={{backgroundImage:'url(./images/temple.webp)',backgroundSize:'cover',backgroundPosition:'center'}}></div>
      <div className="container" style={{marginTop:'100px',marginBottom:'100px'}}></div>
      {/* <div className="container" style={{marginTop:'100px',marginBottom:'100px'}}>
        <div className="row">
            <div className="col-md-12">
                 <h3 style={{marginBottom:'30px',fontSize:'20pt'}}>OFFICE BEARERS</h3>
                <div className="row" style={{marginBottom:'50px'}}>
                   <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/akg.jpg)', backgroundSize:'cover',backgroundPosition:'top'}}></div>
                            <p className="name">AKG Nair</p>
                            <p className="designation">President</p>
                        </div>
                    </div> 
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/vp.jpg)', backgroundSize:'cover',backgroundPosition:'top'}}></div>
                            <p className="name">Janardanan P</p>
                            <p className="designation">Vice President</p>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/sec.jpg)', backgroundSize:'cover',backgroundPosition:'top'}}></div>
                            <p className="name">Muraleedharan Nair</p>
                            <p className="designation">Secretary</p>
                        </div>
                    </div>  
                     <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/tre.jpg)', backgroundSize:'cover',backgroundPosition:'top'}}></div>
                            <p className="name">KV Nadhan</p>
                            <p className="designation">Treasurer</p>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/jsdamo.jpg)', backgroundSize:'cover',backgroundPosition:'top'}}></div>
                            <p className="name">Damodaran Nambiar</p>
                            <p className="designation">Joint Secretary</p>
                        </div>
                    </div> 
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/jskr.jpg)', backgroundSize:'cover',backgroundPosition:'top'}}></div>
                            <p className="name">KR Jayachandran Nair</p>
                            <p className="designation">Joint Secretary</p>
                        </div>
                    </div> 
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/jt.jpg)', backgroundSize:'cover',backgroundPosition:'top'}}></div>
                            <p className="name">Balachandra Pisharody</p>
                            <p className="designation">Joint Treasurer</p>
                        </div>
                    </div>                       
                </div>
           </div>            
        </div>
        <div className="row">
            <div className="col-md-12">
                <h3 style={{marginBottom:'30px',fontSize:'20pt'}}>MANAGING COMMITTEE MEMBERS</h3>
                <div className="row" style={{marginBottom:'50px'}}>
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/Santhamma.jpg)', backgroundSize:'cover',backgroundPosition:'top'}}></div>
                            <p className="name">PR Santhamma</p>
                            <p className="designation"></p>
                        </div>
                    </div>    
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/Prema.jpg)', backgroundSize:'cover',backgroundPosition:'top'}}></div>
                            <p className="name">Prema Narayanan</p>
                            <p className="designation"></p>
                        </div>
                    </div> 
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/Prameela.jpg)', backgroundSize:'cover',backgroundPosition:'top'}}></div>
                            <p className="name">Prameela Nadhan</p>
                            <p className="designation"></p>
                        </div>
                    </div>    
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/Nirmala.jpg)', backgroundSize:'cover',backgroundPosition:'top'}}></div>
                            <p className="name">Nirmala Ramachandran</p>
                            <p className="designation"></p>
                        </div>
                    </div> 
                    <div className="col-md-3" style={{marginTop:'30px'}}>
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/Usha.jpg)', backgroundSize:'cover',backgroundPosition:'top'}}></div>
                            <p className="name">Usha Jayachandran</p>
                            <p className="designation"></p>
                        </div>
                    </div>  
                    <div className="col-md-3" style={{marginTop:'30px'}}>
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/Vilasini.jpg)', backgroundSize:'cover',backgroundPosition:'top'}}></div>
                            <p className="name">Vilasini Muraleedharan</p>
                            <p className="designation"></p>
                        </div>
                    </div> 
                    <div className="col-md-3" style={{marginTop:'30px'}}>
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/Ponnammal.jpg)', backgroundSize:'cover',backgroundPosition:'top'}}></div>
                            <p className="name">Ponnammal Parasuraman</p>
                            <p className="designation"></p>
                        </div>
                    </div>   
                    <div className="col-md-3" style={{marginTop:'30px'}}>
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/Arathi.jpg)', backgroundSize:'cover',backgroundPosition:'top'}}></div>
                            <p className="name">Arathi P</p>
                            <p className="designation"></p>
                        </div>
                    </div>   
                    <div className="col-md-3" style={{marginTop:'30px'}}>
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/Sunil.jpg)', backgroundSize:'cover',backgroundPosition:'top'}}></div>
                            <p className="name">Sunil Menon</p>
                            <p className="designation"></p>
                        </div>
                    </div>   
                    <div className="col-md-3" style={{marginTop:'30px'}}>
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/Mithun.jpg)', backgroundSize:'cover',backgroundPosition:'top'}}></div>
                            <p className="name">Mithun G Nair</p>
                            <p className="designation"></p>
                        </div>
                    </div>               
                    <div className="col-md-3" style={{marginTop:'30px'}}>
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/ajith.jpg)', backgroundSize:'cover',backgroundPosition:'top'}}></div>
                            <p className="name">Ajithkumar</p>
                            <p className="designation"></p>
                        </div>
                    </div>   
                    <div className="col-md-3" style={{marginTop:'30px'}}>
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/Ashok.jpg)', backgroundSize:'cover',backgroundPosition:'top'}}></div>
                            <p className="name">Ashok Nair</p>
                            <p className="designation"></p>
                        </div>
                    </div>   
                    <div className="col-md-3" style={{marginTop:'30px'}}>
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/Sanoop.jpg)', backgroundSize:'cover',backgroundPosition:'top'}}></div>
                            <p className="name">Sanoop Somanathan</p>
                            <p className="designation"></p>
                        </div>
                    </div>   
                      
                </div>
           </div>            
        </div>
        
      </div> */}
    </div>
  );
}

export default Administration;